import {URL_CARRO, URL_CARRO2,  URL_GUIA_TRASLADO, URL_STOCK} from "../../../api/config";
import makeQuery, {descripcionFormatter, QueryMaker} from "../../../api/helper";
import axios from "axios";
import moment from "moment";
import {uuid} from "vue-uuid";

const defaultState = () => ({
  carroGuia: [],
  pedidos: [],
  loadingStock: false,
  loading: false,
  noValidos: [],
  carroPaso: [],
  filtros: {
    fecha_pedida: "",
    origen: window.localStorage.sucursal,
    tipo: "",
    codigo: "",
    descripcion: "",
    solicitante: "",
    destino: ""
  },
  limite: 30,
  offset: 0
})

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    "RESET_STATE"(state) {
      Object.assign(state, defaultState())
    },
    "SET_PEDIDOS"(state, payload) {
      state.pedidos = payload
    },
    "SET_FILTRO"(state, payload) {
      state.filtros[payload.key] = payload.value
    },
    "SET_STOCKS"(state, payload) {
      state.pedidos[payload.index].stock = payload.value
      state.pedidos[payload.index].ubicacion = payload.value
        .find(item => item.sucursal_id === window.localStorage.sucursal_id)
    },
    "SET_ITEM_GUIA"(state, payload) {
      state.pedidos[payload.index][payload.key] = payload.value
    },
    "UPDATE_STATE_KEY"(state, payload) {
      state[payload.key] = payload.data
    },
    "PUSH_CARRO_PASO"(state, payload) {
      state.carroPaso.push({
        producto_id: payload.producto_id,
        linea_id: payload.id,
        cantidad_entregada: parseInt(payload.cantidad_entregada),
        sucursal_destino_id: payload.sucursal_destino_id
      })
    },
    "DELETE_CARRO_PASO"(state, payload) {
      state.carroPaso.splice(payload, 1)
    },
    "LOADING_STOCKS"(state, payload) {
      state.loadingStock = payload
    },
    "LOADING_CREATE"(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    async getCarroGuia({commit, dispatch}) {
      commit("LOADING_STOCKS", true)
      try {
        const query = await dispatch("crearQuery2")
        query.order({field: 'fecha_pedido', type: 'desc'})
        const response = await this._vm.$axios.get(URL_CARRO2 + query.toString())
        commit("SET_PEDIDOS", response.data.items.map(item => ({
          ...item,
          disabled: true,
          check: false
        })))
        //await dispatch("getStock")
        commit("LOADING_STOCKS", false)
      } catch (e) {
        commit("LOADING_STOCKS", false)
        console.error(e)
      }
    },
    getStock({commit, state}) {
      return new Promise((resolve, reject) => {
        let axiosQuerys = []
        state.pedidos.forEach((item) => {
          let query = makeQuery({filtros: [{field: 'producto_id', value: item.producto_id, operator: '='}]})
          axiosQuerys.push(this._vm.$axios.get(URL_STOCK + query))
        })
        axios.all(axiosQuerys).then(
          axios.spread((...responses) => {
            responses.forEach((item, index) => {
              commit("SET_STOCKS", {index, value: item.data.items})
            })
            resolve(responses)
            commit("LOADING_STOCKS", false)
          })
        ).catch(e => {
          reject(e)
          commit("LOADING_STOCKS", false)
          console.error(e)
        })
      })
    },
    getProductoCarroVenta({state, dispatch}) {
      return new Promise(async (resolve, reject) => {
        const query = await dispatch("crearQuery")
        this._vm
          .$axios(URL_CARRO + query)
          .then(resolve)
          .catch(reject)
      })
    },
    crearGuia({commit, state}, payload) {
      commit("LOADING_CREATE", true)
      let guia = payload.map((item, index) => {
        return {
          linea: index + 1,
          productoCarroId: item.producto_carro_id,
          codigo: item.codigo_interno,
          descripcion: item.descripcion,
          cantidad: parseInt(item.cantidad_entregada),
          sucursalDestinoId: item.sucursal_destino_id,
          sucursalDestinoNombre: item.sucursal_destino_nombre,
          productoId: item.producto_id
        }
      })
      return new Promise(((resolve, reject) => {
        this._vm.$axios
          .post(URL_GUIA_TRASLADO, {
            id: uuid.v4(),
            usuario: {id: window.localStorage.usuario_id, nombre: window.localStorage.nombre},
            estado: "pendiente",
            sucursal: {id: window.localStorage.sucursal_id, nombre: window.localStorage.sucursal},
            glosa: guia,
            nombreRecepcionista: ""
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      }))
    },
    async eliminarSeleccionados({state, dispatch, commit}) {
      let querys = []
      const resp = await this._vm.$swal({
        text: "Desea Eliminar los Productos",
        title: "Eliminación de productos",
        confirmButtonColor: "blue",
        confirmButtonText: "Si",
        cancelButtonColor: "red",
        showCancelButton: true,
        cancelButtonText: "No!",
        type: "warning"
      })
      if (resp.value !== true) return
      state.pedidos
        .filter(item => item.check === true)
        .forEach(producto => {
          querys.push(
            this._vm.$axios.put(URL_CARRO + `/${producto.producto_carro_id}`, {
              estado: "inactivo"
            })
          )
        })
      axios.all(querys).then(response => {
        if (querys.length > 1)
          this._vm.$swal("Correcto!", "Productos Eliminados Correctamente", "success")
        else this._vm.$swal("Correcto!", "Producto Eliminado Correctamente", "success")
        commit("RESET_STATE")
        dispatch("getCarroGuia")
      }).catch(error => {
        this._vm.$swal("Error", "Error", "error")
        console.error(error)
      })
    },
    crearQuery2({ state }) {
      const descripcion = descripcionFormatter(state.filtros.descripcion)
      const q = new QueryMaker(2);
      q.eq('fecha_pedido', moment(state.filtros.fecha_pedida).format('DD/MM/YYYY') === 'Invalid date' ? '' :
          moment(state.filtros.fecha_pedida).format('DD/MM/YYYY'))
      for (let item of descripcion) {
        q.contains(item.field, item.value)
      }
      q.contains('codigo_interno', state.filtros.codigo || '')
      q.contains('tipo', state.filtros.tipo || '')
      q.contains('nombre_solicitante', state.filtros.solicitante.nombre || '')
      q.contains('sucursal_destino_nombre', state.filtros.destino.nombre || '')
      q.contains('origen', state.filtros.origen.nombre ? state.filtros.origen.nombre : state.filtros.origen)
      q.eq('estado_solicitud', 'solicitado')
      q.eq('estado', 'activo')
      return q
    },
    crearQuery({state}) {
      const descripcion = descripcionFormatter(state.filtros.descripcion)
      return makeQuery({
        filtros: [
          {
            field: 'fecha_pedido',
            value: moment(state.filtros.fecha_pedida).format('DD/MM/YYYY') === 'Invalid date' ? '' :
              moment(state.filtros.fecha_pedida).format('DD/MM/YYYY'),
            operator: 'CONTAINS'
          },
          ...descripcion,
          {field: 'codigo_interno', value: state.filtros.codigo || '', operator: 'CONTAINS'},
          {field: 'tipo', value: state.filtros.tipo || '', operator: 'CONTAINS'},
          {field: 'nombre_solicitante', value: state.filtros.solicitante.nombre || '', operator: 'CONTAINS'},
          {field: 'nombre_destino', value: state.filtros.destino.nombre || '', operator: 'CONTAINS'},
          {
            field: 'origen',
            value: state.filtros.origen.nombre ? state.filtros.origen.nombre : state.filtros.origen,
            operator: '='
          },
          {field: 'estado_solicitud', value: 'solicitado', operator: '='},
          {field: 'estado', value: 'activo', operator: '='},
        ]
      })
    }
  },
  getters: {
    pedidos: state => state.pedidos,
    destino: state => state.filtros.destino,
    loadingStock: state => state.loadingStock,
    noValidos: state => state.noValidos,
    loading: state => state.loading,
    carroPaso: state => state.carroPaso
  }
}
